import React from "react";
import { useInView } from "framer-motion";
import CountUp from "react-countup";
import { useRef } from "react";
function AccreditationCard({ number, imgSrc, imgAlt, title, description }) {
  const ref = useRef(null);

  const isInView = useInView(ref, {
    //once: true,
    amount: 0.5,
  });

  return (
    <div ref={ref} className="standards-card">
      <div className="standards-number">
        {isInView && (
          <CountUp start={0} end={number} duration={1.8} separator="" />
        )}
      </div>
      {/* <div className="standards_img">
        <img src={imgSrc} alt={imgAlt} />
      </div> */}

      <div className="standards-title">{title}</div>

      <p className="standards-description">{description}</p>
    </div>
  );
}

export default AccreditationCard;
